<template>
	<v-layout row wrap class="content-pad-vert">
		<v-flex x12 sm10 md8 offset-sm1 offset-md2 class="pa-3 text-xs-center">
			<h1>Messages</h1>
			<v-btn @click="markAll" class="info" v-if="unreadNotifications">Mark all as read</v-btn>
			<div v-for="(notification, index) in getNotifications" :key="index" @click="go(notification)" class="mt-3">
				<v-card style="cursor: pointer;">
					<v-card-title>
						<h3>{{notification.title}}</h3>
						<v-spacer></v-spacer>
						<v-btn flat v-if="!getNotifications[index].read" class="warning white--text" @click.stop="markRead(notification)">Mark as read</v-btn>
						<v-chip v-else>Read</v-chip>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<p>{{notification.description}}</p>
					</v-card-text>
				</v-card>
			</div>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
export default {
	methods: {
		...mapActions(['setModalOpen', 'setNotifications', 'setNotificationRead']),
		go(notification) {
			this.markRead(notification)
			this.$router.push(notification.link)
		},
		markAll() {
			let tempNotifications = []
			for (var i = 0; i < this.getNotifications.length; i++) {
				var tempNotif = Object.assign({}, this.getNotifications[i])
				tempNotif.read = true
				tempNotifications.push(tempNotif)
			}
			this.setNotifications(tempNotifications)
			axios.post('/api/v1/notifications/mark-all-read/').then((response) => {
			}).catch((error) => {
				console.error(error)
			})
			console.log(this.getNotifications)
		},
		markRead(notification) {
			let tempNotif = Object.assign({}, notification)
			tempNotif.read = true
			this.setNotificationRead(tempNotif)
			axios.post('/api/v1/notifications/' + notification.pk + '/mark-read/').then((response) => {
			}).catch((error) => {
				console.error(error)
			})
			console.log(this.getNotifications)
		}
	},
	computed: {
		...mapGetters(['getNotifications']),
		unreadNotifications () {
			for (var i = 0; i < this.getNotifications.length; i++) {
				if (this.getNotifications[i]) {
					if (this.getNotifications[i].read === false) {
						return true
					}
				}
			}
		},
	}
}
</script>
